
// Get the best thumbnail for a feature
export const getThumbnails = (feature) => {
    if (!feature || !feature.properties) return null;

    const { vibemap_images = [], thumbnail_url } = feature.properties;
    const thumbs = [];

    let best_thumbnail = thumbnail_url;
    if (!best_thumbnail && vibemap_images.length > 0) {
        best_thumbnail = typeof vibemap_images[0] === 'string'
            ? vibemap_images[0]
            : vibemap_images[0]?.thumbnail_url;
    }

    if (best_thumbnail) thumbs.push(best_thumbnail);

    if (feature.properties.hotspots_place) {
        const best_places_thumb = getThumbnails(feature.properties.hotspots_place);
        if (best_places_thumb) thumbs.push(best_places_thumb);
    }

    return thumbs.length > 0 ? thumbs[0] : null;
}